import React from "react";
import { useSortable, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { money, mediaUrl } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { GripVertical, Pencil, Trash2, ImageOff, Copy, Languages } from "lucide-react";

const missingTr = (p) => ["en", "de", "fr"].some((l) => !p[`name_${l}`]);

function Row({ p, onEdit, onDelete, onToggle, onDuplicate }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: p.id });
  return (
    <div ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition, zIndex: isDragging ? 30 : undefined, position: "relative" }}
      className={`flex flex-wrap sm:flex-nowrap items-center gap-2 sm:gap-3 p-3 bg-white ${isDragging ? "shadow-xl rounded-xl opacity-90" : ""} ${p.available ? "" : "bg-cream-muted/60"}`} data-testid={`product-row-${p.id}`}>
      <button {...attributes} {...listeners} className="cursor-grab active:cursor-grabbing text-forest/50 hover:text-forest touch-none" data-testid={`product-drag-${p.id}`}><GripVertical className="w-5 h-5" /></button>
      <div className="w-12 h-12 rounded-lg bg-cream-muted overflow-hidden flex items-center justify-center shrink-0">
        {p.image ? <img src={mediaUrl(p.image)} alt="" className="w-full h-full object-cover" /> : <ImageOff className="w-4 h-4 text-forest/30" />}
      </div>
      <div className={`flex-1 min-w-[8rem] ${p.available ? "" : "opacity-50"}`}>
        <div className="font-medium text-forest-deep truncate">{p.name_bg || p.name}</div>
        <div className="text-xs text-muted-foreground truncate flex items-center gap-1">
          {missingTr(p) && <Languages className="w-3 h-3 text-amber-600" title="Липсват преводи" />}
          {[p.weight, p.group, p.send_to_kitchen ? "кухня" : "без кухня", !p.show_on_website && "не е на сайта"].filter(Boolean).join(" · ")}
        </div>
      </div>
      <div className="font-semibold text-gold-dark whitespace-nowrap" data-testid={`product-price-${p.id}`}>{money(p.price)}</div>
      <div className="flex flex-col items-center gap-0.5">
        <Switch checked={p.available} onCheckedChange={() => onToggle(p)} data-testid={`product-toggle-${p.id}`} />
        <span className="text-[10px] text-muted-foreground">{p.available ? "видим" : "скрит"}</span>
      </div>
      <button onClick={() => onDuplicate(p)} className="text-forest/70 p-1" title="Копирай" data-testid={`duplicate-product-${p.id}`}><Copy className="w-4 h-4" /></button>
      <button onClick={() => onEdit(p)} className="text-gold-dark p-1" data-testid={`edit-product-${p.id}`}><Pencil className="w-4 h-4" /></button>
      <button onClick={() => onDelete(p.id)} className="text-destructive p-1" data-testid={`delete-product-${p.id}`}><Trash2 className="w-4 h-4" /></button>
    </div>
  );
}

export const ProductList = ({ items, ...handlers }) => (
  <SortableContext items={items.map((p) => p.id)} strategy={verticalListSortingStrategy}>
    <div className="bg-white rounded-2xl border border-gold/10 shadow-soft divide-y divide-gold/10" data-testid="mm-product-list">
      {items.map((p) => <Row key={p.id} p={p} {...handlers} />)}
      {items.length === 0 && <div className="p-8 text-center text-muted-foreground">Няма ястия в тази категория</div>}
    </div>
  </SortableContext>
);
